import { apiProxyRequest as request } from "Api/apiProxyRequest";

import type { EnvironmentTypeAccess } from "Api/organizations/member/projectAccess/ProjectAccess.types";

export const updateProjectUserAccess = (
  projectId: string,
  userId: string,
  permissions: Array<EnvironmentTypeAccess>
) =>
  request(`/projects/${projectId}/user-access/${userId}`, "PATCH", {
    permissions
  });
